import { render, staticRenderFns } from "./StepTab3.vue?vue&type=template&id=5feabd88&scoped=true"
import script from "./StepTab3.vue?vue&type=script&lang=js"
export * from "./StepTab3.vue?vue&type=script&lang=js"
import style0 from "./StepTab3.vue?vue&type=style&index=0&id=5feabd88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feabd88",
  null
  
)

export default component.exports